module.exports = __webpack_public_path__ + "img/bg_resize_castle_glow.581e04a7.png";